// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: "9.14.1",
  copyright: "vipHomeLink",
  tenantID: "42150095384094-32",
  tenantName: "vipHome.app",
  appAPI: "https://vhl-app-api-md7g2hbyoq-uc.a.run.app/api",
  recaptchaKey: "6Lfd_1wrAAAAANBPSyMg5FzxEiWnrM2g-PaxHzHk",
  getApiKey: "PSfxVC9sZ8dYzqCiuXoScFKSXvqkcNPNYj3S68DTZrFkbTDziq9PWW2A12jU0SHX",
  postApiKey: "fuRWTYD5bA8#4Q^&&F1P",
  gaMeasurementId:"",
  leakBotApiKey: "UPfxVC9sZ8dYzqCiu78ScFKSLvqkcNPNYj3S68DTZrFkbTDziq9PWt2A12jU5LKF"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
